import Redactor from '../../redactor.esm.min.js'
import { computedStyle, registerToolbarButton } from '../registerButton'

class MpFontColorPlugin {
    static defaultOptions = {
        input: true
    }

    static defaultLang = {
        en: {
            mpFontColor: {
                title: 'Font Color'
            }
        }
    }

    constructor(app, options = {}) {
        this.app = app
        this.options = options
        this.currentlySelectedFontColor = ''
        this.defaultColor = options.defaultColor
    }

    start() {
        registerToolbarButton(this.app, 'mpFontColor', this._createToolbarButton())
    }

    updateColor(color, instant = false) {
        if (!instant) this.app.restoreSelection()
        this.app.inline.set({ tag: 'span', styles: { color: color } })
        this._checkForListItems(color)
    }

    _checkForListItems(color) {
        const selection = this.app.getService('selection')
        const inlines = selection.getNodes({ types: 'inline' }) || []
        if (inlines.length === 0) return

        const seen = new Set()
        inlines.forEach((node) => {
            const li = node.closest ? node.closest('li') : null
            if (li && !seen.has(li)) {
                seen.add(li)
                li.style.color = color
            }
        })
    }

    _createToolbarButton() {
        return {
            title: this.app.getLang('mpFontColor.title'),
            color: true,
            icon: '<svg width="22" height="22" style="margin-left: -2px;" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 6C11.4696 6 10.9609 6.21071 10.5858 6.58579C10.2107 6.96086 10 7.46957 10 8V10H14V8C14 7.46957 13.7893 6.96086 13.4142 6.58579C13.0391 6.21071 12.5304 6 12 6ZM16 8C16 6.93913 15.5786 5.92172 14.8284 5.17157C14.0783 4.42143 13.0609 4 12 4C10.9391 4 9.92172 4.42143 9.17157 5.17157C8.42143 5.92172 8 6.93913 8 8V15C8 15.5523 8.44772 16 9 16C9.55228 16 10 15.5523 10 15V12H14V15C14 15.5523 14.4477 16 15 16C15.5523 16 16 15.5523 16 15V8ZM4 19C4 18.4477 4.44772 18 5 18H19C19.5523 18 20 18.4477 20 19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19Z" fill="#000000"/></svg>',
            position: { before: 'moreinline' },
            command: 'mpFontColor.popup'
        }
    }

    popup(_params, { button, el } = {}) {
        this.app.saveSelection()
        this.app.dropdown.create('mpFontColor', { items: [] })
        this.app.dropdown.open(button || el)

        if (this.app.dropdown.getName() !== 'mpFontColor') return

        const selection = this.app.getService('selection')
        const inlines = selection.getNodes({ types: 'inline' }) || []
        let selectedFontColor = this.defaultColor
        if (inlines.length) {
            selectedFontColor = computedStyle(inlines[0], 'color') || this.defaultColor
        }

        const generateColorPicker = this.options.generateColorPicker
        if (typeof generateColorPicker === 'function') {
            generateColorPicker('mpFontColor', selectedFontColor)
        }
    }
}

Redactor.addPlugin('mpFontColor', MpFontColorPlugin)
